import React from "react";
import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <>
      <div className="container">
        <div id="top1" className="row">
          <div id="top1right" className="col-md-12 col-sm-12 col-xs-12 my-3">
            <h2>Terms of Use</h2>
          </div>
        </div>
      </div>
      <div class="region region-content">
        <div id="block-system-main" class="block block-system">
          <div class="content">
            <div id="node-2551549" class="node node-panel clearfix">
              <div class="content">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 inner-timeline">
                      <div class="panel-pane pane-node-body">
                        <div class="pane-content">
                          <div class="field field-name-body field-type-text-with-summary field-label-hidden">
                            <div class="field-items">
                              <div class="field-item even">
                                <p>
                                  It is a condition of using this site as a
                                  visitor or advertiser that you accept and
                                  agree to abide by these terms and conditions.
                                </p>
                                <p>
                                  <strong>General Terms and Conditions</strong>
                                </p>
                                <p>
                                  <strong>Copyright:</strong>
                                </p>
                                <p>
                                  We hold intellectual copyright of this Website
                                  and its related content and databases.
                                  Information taken from the Website, including
                                  details of companies listed and editorial
                                  content cannot be copied without the expressed
                                  permission of Arabia Weddings, nor can it be
                                  used for any commercial purpose.
                                </p>
                                <p>
                                  <strong>Availability</strong>:
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      We do everything materially possible to
                                      ensure that the Service is accessible 24
                                      hours a day, 7 days a week; however, we
                                      cannot be held responsible for the
                                      temporary unavailability of all or parts
                                      of the site due to faults or updates.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      We reserve the right to interrupt the
                                      Service due to maintenance or upgrade work
                                      on the same.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      We reserve the right to block access to
                                      the Site or a specific Page without
                                      warning in the event that these Terms
                                      &amp; Conditions are not respected.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      We reserve the right to delete and edit at
                                      any moment and without warning from a Page
                                      any content deemed to be offensive or when
                                      there is reasonable doubt as to whether it
                                      breaks the law.
                                    </p>
                                  </li>
                                </ul>
                                <p>
                                  <strong>Warranty</strong>:
                                </p>
                                <p>
                                  We make no warranties or representations,
                                  whether expressed or implied, in relation to
                                  the Website or the Content, including but not
                                  limited to, implied warranties or conditions
                                  of completeness, accuracy, satisfactory
                                  quality and fitness for a particular purpose.
                                  Some of the Content is supplied to us
                                  (directly and indirectly) by third parties,
                                  and accordingly we can offer no warranty of
                                  whatever nature in relation to such Content.
                                </p>
                                <p>
                                  <strong>Liability</strong>:
                                </p>
                                <p>
                                  We shall not be liable in any case for any
                                  loss or damage whatsoever arising directly or
                                  indirectly from or in any way connected with
                                  the Website or your use of or reliance upon
                                  the Content or any information you obtain by
                                  means of the Website whether based on
                                  contract, a wrongful act, negligence,
                                  statutory duty or otherwise, even if we or any
                                  of our Vendors has been advised of the
                                  possibility of such loss or damage. Your
                                  statutory rights in relation to any goods or
                                  services purchased through the Website are not
                                  affected.
                                </p>
                                <p>
                                  <strong>Links to Third-Party Sites:</strong>
                                </p>
                                <p>
                                  This Website may contain hyperlinks to other
                                  websites. We acknowledge that we are not
                                  responsible for the availability of such
                                  external sites, and we do not endorse and are
                                  not responsible or liable for any content,
                                  advertising, products or other materials on or
                                  available from such sites.
                                </p>
                                <p>
                                  <strong>Passwords</strong>:
                                </p>
                                <p>
                                  We reserve the right to change all or any of
                                  the passwords used in connection with the
                                  Website, and to suspend your access to the
                                  Website without prior notification. Password
                                  reminders can only be sent to the email
                                  address specified on the account.
                                </p>
                                <p>
                                  <strong>Services booked:</strong>
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      We take no responsibility for any service
                                      or business that is booked with Vendors
                                      and third parties via our Website or for
                                      the delivery or fulfillment of services
                                      supplied directly by advertisers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      We will not be held accountable for any
                                      possible changes applied to promotions,
                                      special deals, offers, or discounts
                                      provided by Vendors and third parties.
                                      Once the expiry date has passed the
                                      promotion will no longer be valid.
                                    </p>
                                  </li>
                                </ul>
                                <h3>Clients' Statements and Liability</h3>
                                <ul>
                                  <li>
                                    <p>
                                      Users (vendors, brides, grooms... anyone
                                      using our Website) agree to use our
                                      Services in accordance with these Terms
                                      &amp; Conditions, the law, morality,
                                      generally accepted good customs and public
                                      order.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Users agree not to publish content that
                                      may be offensive and that is not in
                                      keeping with applicable laws.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Users waive the right to take any actions
                                      against Arabia Weddings or ask for
                                      responsibilities due to the data published
                                      on this Website.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Users filling in any form on the Website
                                      guarantee the truthfulness of the
                                      information provided regarding their
                                      identity, email address, company
                                      information, wedding information… entered
                                      on the forms.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Users waive the right to take any action
                                      against Arabia Weddings to defend their
                                      image, intellectual property and private
                                      life due to the data published on the
                                      Website.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Users agree to resolve any dispute that
                                      may arise among them without the mediation
                                      of Arabia Weddings.
                                    </p>
                                  </li>
                                </ul>
                                <h3>Intellectual Property</h3>
                                <p>
                                  <strong>We</strong> shall not be liable for
                                  damages of any kind that may arise due to a
                                  lack of accuracy, completeness, timeliness,
                                  nor for those due to errors or omissions
                                  related to the information and services
                                  contained on the Website.
                                </p>
                                <p>
                                  Arabia Weddings allows registered users to
                                  input images, videos, logos, and description
                                  of services on directory listings of the
                                  website. The content published is largely
                                  prepared either by us. We do not guarantee in
                                  any way the accuracy of the content and images
                                  published on directory listings and we are
                                  expressly exempt from any liability for
                                  damages of any kind that may result from the
                                  lack or errors in the content published and
                                  images published.
                                </p>
                                <p>
                                  We may offer user links to other websites
                                  managed and controlled by third parties, with
                                  the sole function of facilitating users to
                                  search for and share information, content and
                                  services on the Internet. We do not manage or
                                  own the content, services and information
                                  available on such linked websites, or endorse,
                                  supervise or control in any way the content,
                                  services and any material of any nature
                                  therein, assuming the user has full
                                  responsibility for navigating through them.
                                </p>
                              </div>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
